import { render } from "./ContentManagement.vue?vue&type=template&id=58636840"
import script from "./ContentManagement.vue?vue&type=script&lang=js"
export * from "./ContentManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__